import React, { Fragment } from 'react';
import { Box, Paper, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router'; // import the react-router-dom components
import TranslatedText from '../../components/atoms/translated_text';
import PaymentActions from 'redux/reducers/payment_list_reducer/actions';
import useStyles from './styles';
import DatatableList from './components/datatable';
import clsx from 'clsx';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import { TableDefaultFetchValues, Translations } from './configuration';
import BaseModal from 'components/molecules/base_modal';
import { ModalIDs } from 'redux/reducers/gl_modal_reducer/types';
import EditPaymentInfoForm from './components/edit_payment_info';
import PaymentsReceivedListActions from 'redux/reducers/payments_received_list_reducer/actions';
import useQuery from 'custom_hooks/useQuery';

const PaymentInfoPage = (props: any) => {
  // console.log('Render PaymentInfoPage');
  const dispatch = useDispatch();
  const classes = useStyles();

  const query = useQuery();
  const paymentRef = query.get('paymentRef');
  const schemeType = query.get('schemeType');
  const msconCountry = query.get('msconCountry');
  let searchParams = {
    ...(paymentRef && { paymentRef }),
    ...(schemeType && { schemeType }),
    ...(msconCountry && { msconCountry }),
  };

  React.useEffect(() => {
    dispatch(PaymentsReceivedListActions.fetchMemberStateCountriesAction());
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(
      PaymentActions.fetchPaymentInfoAction({
        sortField: TableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY,
        page: TableDefaultFetchValues.TABLE_DEFAULT_PAGE,
        pageSize: TableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
        order: TableDefaultFetchValues.TABLE_DEFAULT_ORDER,
        ...searchParams,
      })
    );
  }, [dispatch, searchParams]);

  return (
    /*================== Reimbursements Page ==================*/
    <div>
      {/*================== Reimbursements Page - Header ==================*/}
      <Paper
        className={clsx(classes.titleLayout)}
        elevation={0}
        variant={'outlined'}
        square
      >
        {/* Reimbursements Page - Header - Title, Icon & Actions */}
        <Box display="flex" alignItems={'center'}>
          {/* Icon */}
          <AssignmentOutlinedIcon style={{ marginRight: '.75rem' }} />
          {/* Title */}
          <Typography component={'p'} variant={'h6'}>
            <TranslatedText
              textMap={Translations.page_title}
              defaultText={Translations.page_title.English}
            />
          </Typography>
        </Box>
      </Paper>
      {/*--------------- end of Reimbursements Page - Header ---------------*/}

      {/*================== Reimbursements Page - Body ==================*/}
      <div style={{ padding: 12 }}>
        {/*================== Reimbursements Page - Body - Reimbursements Section ==================*/}
        <div className={classes.cardLayout}>
          {/* Reimbursements Page - Body - Reimbursements Section - Title */}
          <Typography
            component={'p'}
            variant={'h5'}
            style={{ marginBottom: '.5rem' }}
          >
            <TranslatedText
              textMap={Translations.title}
              defaultText={Translations.title.English}
            />
          </Typography>

          {/* Reimbursements Page - Body - Reimbursements Section - Description */}
          <Typography component={'p'} variant={'subtitle1'}>
            <TranslatedText
              textMap={Translations.description}
              defaultText={Translations.description.English}
            />
          </Typography>

          {/* Reimbursements Page - Body - Reimbursements Section - Reimbursements List Table */}
          <div className={classes.tableList}>
            <DatatableList />
          </div>
        </div>
        {/*--------------- end of Reimbursements Page - Body - Reimbursements Section ---------------*/}
      </div>
      <Modals />
      {/*--------------- end of Reimbursements Page - Body ---------------*/}
    </div>
    /*--------------- end of Reimbursements Page ---------------*/

    // <div>
    //   <Paper
    //     className={clsx(classes.cardLayout, classes.titleLayout)}
    //     elevation={0}
    //     variant={'outlined'}
    //     square
    //   >
    //     <Box display="flex" alignItems={'center'}>
    //       <AssignmentOutlinedIcon style={{ marginRight: '.75rem' }} />
    //       <Typography component={'p'} variant={'h6'}>
    //         <TranslatedText
    //           textMap={Translations.page_title}
    //           defaultText={Translations.page_title.English}
    //         />
    //       </Typography>
    //     </Box>
    //   </Paper>
    //   <div className={classes.contentContainer}>
    //     <DatatableList />
    //   </div>
    //   <Modals />
    // </div>
  );
};

const Modals = () => {
  return (
    <Fragment>
      <BaseModal
        modalID={ModalIDs.MODAL_UPDATE_PAYMENT_INFO_REFERENCE}
        renderHeader={() => (
          <TranslatedText textMap={Translations.payment_info_reference} />
        )}
        renderContent={(props) => <EditPaymentInfoForm {...props} />}
      />
    </Fragment>
  );
};

export default withRouter(PaymentInfoPage);
